"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CssClassNames2 = _interopRequireDefault(require("../../scss/CssClassNames"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
var _excluded = ["type", "value", "onChange", "onFocus", "onBlur", "label", "extraClassName", "id", "name", "placeholder", "options", "rows", "required", "error", "success", "isCustomCheckbox", "pattern", "extraAtts", "size"];
/* eslint-disable jsx-a11y/no-onchange */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var _CssClassNames = new _CssClassNames2["default"](_stylesModule["default"], ['utility', 'transition']),
  className = _CssClassNames.className;
var FormItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var type = _ref.type,
    value = _ref.value,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    extraClassName = _ref.extraClassName,
    id = _ref.id,
    name = _ref.name,
    placeholder = _ref.placeholder,
    options = _ref.options,
    rows = _ref.rows,
    required = _ref.required,
    error = _ref.error,
    success = _ref.success,
    _ref$isCustomCheckbox = _ref.isCustomCheckbox,
    isCustomCheckbox = _ref$isCustomCheckbox === void 0 ? false : _ref$isCustomCheckbox,
    pattern = _ref.pattern,
    extraAtts = _ref.extraAtts,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  var inputItem = null;
  switch (type) {
    case 'select':
      inputItem = /*#__PURE__*/_react["default"].createElement("select", _extends({
        ref: ref,
        value: value,
        onChange: onChange,
        onFocus: onFocus
      }, onBlur && {
        onBlur: onBlur
      }, className("custom-select ".concat(size ? "custom-select-".concat(size) : '', " ").concat(error ? 'is-invalid' : '', " ").concat(success ? 'is-valid' : ''), extraClassName), {
        id: id
      }, name && {
        name: name
      }, props['aria-label'] && !label && {
        'aria-label': props['aria-label']
      }, extraAtts && _objectSpread({}, extraAtts)), /*#__PURE__*/_react["default"].createElement("option", {
        disabled: "disabled",
        value: ""
      }, placeholder), options && typeof options.map !== 'undefined' ? options.map(function (value, k) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: k,
          value: value
        }, value);
      }) : Object.keys(options).map(function (value, k) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: k,
          value: value
        }, options[value]);
      }));
      break;
    case 'textarea':
      inputItem = /*#__PURE__*/_react["default"].createElement("textarea", _extends({
        ref: ref,
        value: value,
        onChange: onChange,
        onFocus: onFocus
      }, onBlur && {
        onBlur: onBlur
      }, {
        type: type
      }, className("form-control ".concat(size ? "form-control-".concat(size) : '', " ").concat(error ? 'is-invalid' : '', " ").concat(success ? 'is-valid' : ''), extraClassName), {
        id: id
      }, name && {
        name: name
      }, {
        placeholder: placeholder,
        rows: rows,
        required: required
      }, props['aria-label'] && !label && {
        'aria-label': props['aria-label']
      }));
      break;
    case 'checkbox':
    case 'radio':
      inputItem = /*#__PURE__*/_react["default"].createElement("input", _extends({
        ref: ref,
        value: value,
        onChange: onChange,
        onFocus: onFocus,
        type: type
      }, className("".concat(isCustomCheckbox ? 'custom-control-input' : 'form-check-input', " ").concat(error ? 'is-invalid' : '', " ").concat(success ? 'is-valid' : ''), extraClassName), {
        id: id
      }, name && {
        name: name
      }, {
        placeholder: placeholder,
        required: required
      }, props['aria-label'] && !label && {
        'aria-label': props['aria-label']
      }));
      break;
    default:
      inputItem = /*#__PURE__*/_react["default"].createElement("input", _extends({
        ref: ref,
        value: value,
        onChange: onChange,
        onFocus: onFocus
      }, onBlur && {
        onBlur: onBlur
      }, {
        type: type
      }, className("form-control ".concat(size ? "form-control-".concat(size) : '', " ").concat(error ? 'is-invalid' : '', " ").concat(success ? 'is-valid' : ''), extraClassName), {
        id: id
      }, name && {
        name: name
      }, pattern && {
        pattern: pattern
      }, {
        placeholder: placeholder,
        required: required
      }, extraAtts && _objectSpread({}, extraAtts), props['aria-label'] && !label && {
        'aria-label': props['aria-label']
      }));
  }
  return inputItem;
});
var _default = FormItem;
exports["default"] = _default;